import * as React from "react"

export const TimeGreen: React.FC<{ size: number }> = ({ size }) => (
  <svg id="b" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" width={`${size}mm`} height={`${size}mm`} viewBox="0 0 15.496 15.467">
    <g id="c" data-name="Layer 1">
      <g id="d" data-name="0xCbdb.tif">
        <g>
          <path d="m7.464.005c2.062-.074,4.094.668,5.641,2.135.99.939,1.712,2.135,2.091,3.446.768,2.655.038,5.584-1.891,7.562-1.855,1.903-4.677,2.71-7.264,2.138-2.207-.488-4.1-1.969-5.15-3.966C-.132,9.376-.295,7.046.512,4.996,1.373,2.809,3.033,1.13,5.281.394,5.999.159,6.733.031,7.464.005Zm.268,14.203c3.585.009,6.497-2.888,6.508-6.475.011-3.546-2.891-6.475-6.428-6.485-3.597-.01-6.522,2.869-6.532,6.431-.01,3.602,2.873,6.519,6.452,6.529Z" fill="#5eb158" />
          <path d="m7.058,5.603c0-.704-.007-1.409.002-2.113.007-.52.532-.848.994-.628.289.138.409.379.408.695-.004,1.156-.045,2.336-.024,3.468.006.298.117.575.346.767.558.467,1.052,1.007,1.562,1.529.406.415.23,1.061-.32,1.197-.242.06-.465.003-.641-.17-.716-.709-1.426-1.422-2.137-2.136-.125-.125-.194-.295-.193-.472.003-.712.001-1.424.001-2.136h0Z" fill="#5eb158" />
        </g>
      </g>
    </g>
  </svg>
)